const WindIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
      stroke="#2E90FA"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.786 3.12063C12.0958 2.80905 12.4777 2.57882 12.8978 2.45042C13.318 2.32201 13.7634 2.29941 14.1944 2.38462C14.6254 2.46982 15.0287 2.6602 15.3684 2.93882C15.7081 3.21744 15.9736 3.57568 16.1415 3.98168C16.3094 4.38769 16.3744 4.82888 16.3306 5.26605C16.2869 5.70321 16.1359 6.1228 15.8909 6.48751C15.6459 6.85222 15.3146 7.15076 14.9265 7.35658C14.5383 7.56241 14.1054 7.66914 13.666 7.66729H1.66602M15.786 22.8806C16.0958 23.1922 16.4777 23.4224 16.8978 23.5508C17.318 23.6792 17.7634 23.7018 18.1944 23.6166C18.6254 23.5314 19.0287 23.3411 19.3684 23.0624C19.7081 22.7838 19.9736 22.4256 20.1415 22.0196C20.3094 21.6136 20.3744 21.1724 20.3306 20.7352C20.2869 20.298 20.1359 19.8785 19.8909 19.5137C19.6459 19.149 19.3146 18.8505 18.9265 18.6447C18.5383 18.4389 18.1054 18.3321 17.666 18.334H1.66602M22.6393 7.30729C23.0271 6.92048 23.5043 6.63518 24.0286 6.47664C24.5529 6.31811 25.1082 6.29121 25.6453 6.39834C26.1825 6.50547 26.685 6.74332 27.1083 7.09085C27.5317 7.43839 27.8629 7.88489 28.0727 8.39088C28.2824 8.89687 28.3642 9.44675 28.3109 9.99189C28.2575 10.537 28.0707 11.0606 27.7668 11.5164C27.463 11.9721 27.0515 12.3459 26.5688 12.6048C26.0861 12.8637 25.5471 12.9996 24.9993 13.0006H1.66602"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default WindIcon
